import { render } from "./dpTable.vue?vue&type=template&id=630ccb28"
import script from "./dpTable.vue?vue&type=script&lang=js"
export * from "./dpTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__